import type { ReactNode } from "react";

interface LobbySlots {
  title: string;
  banner: ReactNode;
  primary: ReactNode;
  support: ReactNode;
  live: ReactNode;
  dialogs: ReactNode;
}

/** Phone order prioritizes joining a game, then daily progress, then discovery. */
export function MobileLobbyView({ title, banner, primary, support, live, dialogs }: LobbySlots) {
  return <div className="screen-stack home-screen lobby-mobile">
    <h1 className="sr-only">{title}</h1>{banner}{primary}{support}{live}{dialogs}
  </div>;
}

/** Wide composition gives progress and discovery a separate supporting region. */
export function WideLobbyView({ title, banner, primary, support, live, dialogs }: LobbySlots) {
  return <div className="screen-stack home-screen lobby-wide">
    <h1 className="sr-only">{title}</h1>{banner}{primary}
    <div className="wide-lobby-secondary">{support}{live}</div>
    {dialogs}
  </div>;
}
